import { getHeadDetails }from './header/header.js';
import { getSideNavDetails } from './side-nav/side-nav';

export var base = `<div id="header"></div>
<div>
<aside>
  <section id="mySidebar" class=" sidebarNav sidebar leftbar full-sidebar">

    <div id="mainSideNav"></div>
  </section>
</aside></div>
<main id="subapp-container" ></main>`;

  export function setBase() {
    document.getElementById("base").innerHTML = base;

    // loads header
    getHeadDetails();

    //loads sidenav 
    getSideNavDetails();
  }

